import { combineReducers } from '@reduxjs/toolkit'
import user from './slices/user.slice'
import gameSetting from './slices/gameSetting.slice'
import auth from './slices/auth.slice'
import games from './slices/games.slice'
import settings from './slices/settings.slice'
import wallet from './slices/wallet.slice'
import lobby from './slices/lobby.slice'
import bonus from './slices/bonus.slice'
import transactions from './slices/usersTransaction.slice'
import loader from './slices/loader.slice'
import searchPopup from './slices/searchPopup.slice'
import chat from './slices/chat.slice'
import promotion from './slices/promotion.slice'
import cryptoCoin from './slices/cryptocoin.slice'
import announcement from './slices/announcement.slice'
import limits from './slices/limits.slice'
import moonpay from './slices/moonpay.slice'
import predictionMarket from 'games/PredictionMarket/slice-thunk/predictionMarket.slice'
import casino from './slices/casino.slice'
import didit from './slices/didit.slice'

const rootReducer = combineReducers({
  user,
  settings,
  gameSetting,
  auth,
  games,
  casino,
  wallet,
  lobby,
  bonus,
  transactions,
  loader,
  searchPopup,
  chat,
  promotion,
  cryptoCoin,
  announcement,
  limits,
  moonpay,
  predictionMarket,
  didit
})

export default rootReducer
